import { VariantProps } from "class-variance-authority";
import { BanIcon, Verified } from "lucide-react";
import { Customer } from "@/api/types";
import { Badge, badgeVariants } from "@/components/ui/badge";

export function OptedOutBadge(props: {
  customer: Customer;
  variant?: VariantProps<typeof badgeVariants>["variant"];
}) {
  return props.customer.optout ? (
    <Badge
      variant="outline"
      className="bg-red-500/10 border-red-500/50 text-red-700 dark:text-red-400"
    >
      <BanIcon className="w-3 h-3 mr-1" />
      Unsubscribed
    </Badge>
  ) : (
    <Badge
      variant="outline"
      className="bg-green-500/10 border-green-500/50 text-green-700 dark:text-green-400"
    >
      <Verified className="w-4 h-4 mr-1 text-white fill-green-600 dark:text-green-400 dark:fill-none" />
      Subscribed
    </Badge>
  );
}
